import { render, staticRenderFns } from "./protocolCompanyList.vue?vue&type=template&id=45c295ac&scoped=true"
import script from "./protocolCompanyList.vue?vue&type=script&lang=js"
export * from "./protocolCompanyList.vue?vue&type=script&lang=js"
import style0 from "./protocolCompanyList.vue?vue&type=style&index=0&id=45c295ac&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c295ac",
  null
  
)

export default component.exports